module.exports = __webpack_public_path__ + "img/videopingl.be821b8b.png";